type VideoConferenceCallLink = {
  uri: string;
};

const videoConferenceCallLink: VideoConferenceCallLink = {
  uri: "",
};

export type { VideoConferenceCallLink };

export { videoConferenceCallLink };
